import { createSelector } from '@reduxjs/toolkit'

import { FILE_TYPE_SOCIAL_SECURITY_AUTH_FORM, FILE_TYPE_SOCIAL_SECURITY_NUMBER_VERIFICATION } from '@/constants'
import { SocialSecurityProfileStatus } from '@/models'

const getProfile = (state) => state.profile
const getSocialSecurityProfileSlice = (state) => state.socialSecurityProfile
const getUserFilesSlice = (state) => state.userFiles
const getSocialSecurityProfileData = (state) => getSocialSecurityProfileSlice(state).data || {}
const getUserFiles = (state) => getUserFilesSlice(state).items || []

const hasFetchedSocialSecurityProfile = (state) => getSocialSecurityProfileSlice(state).fetchSuccessful || false

const hasFilledSectionVerification = () => {
    return true
}

const hasFilledSectionAuthorisation = (state) => {
    const { hasUploadedAuthorisationForm } = getSocialSecurityProfileData(state)

    return hasUploadedAuthorisationForm
}

const getSocialSecurityNumberVerificationFiles = (state) =>
    getUserFiles(state).filter(({ fileType }) => fileType === FILE_TYPE_SOCIAL_SECURITY_NUMBER_VERIFICATION)

const getSocialSecurityAuthFiles = (state) =>
    getUserFiles(state).filter(({ fileType }) => fileType === FILE_TYPE_SOCIAL_SECURITY_AUTH_FORM)

const SOCIAL_SECURITY_PENDING_STATUSES = [
    SocialSecurityProfileStatus.Started,
    SocialSecurityProfileStatus.Submitted,
    SocialSecurityProfileStatus.InformationRequested,
]
const isStatusCompleted = (state) => getSocialSecurityProfileData(state).status === SocialSecurityProfileStatus.Complete

const isStatusPending = (state) => {
    const socialSecurityStatus = getSocialSecurityProfileData(state).status
    const { isNewSelfEmployed } = getProfile(state)
    if (!isNewSelfEmployed) return false
    if (!socialSecurityStatus) return true
    return SOCIAL_SECURITY_PENDING_STATUSES.includes(socialSecurityStatus)
}

const isStatusBeyondStarted = (state) => {
    const { status } = getSocialSecurityProfileData(state)
    return !!status && status !== SocialSecurityProfileStatus.Started
}

const socialSecurityProfileSelector = createSelector(
    [
        getSocialSecurityProfileData,
        hasFetchedSocialSecurityProfile,
        hasFilledSectionVerification,
        hasFilledSectionAuthorisation,
        getSocialSecurityNumberVerificationFiles,
        getSocialSecurityAuthFiles,
        isStatusBeyondStarted,
        isStatusCompleted,
        isStatusPending,
    ],
    (
        socialSecurityProfileData,
        fetchSuccessful,
        isVerificationSectionFilled,
        isAuthorisationSectionFilled,
        filesSocialSecurityNumberVerification,
        filesAuthForm,
        isSocialSecurityBeyondStarted,
        isSocialSecurityCompleted,
        isSocialSecurityPending
    ) => ({
        ...socialSecurityProfileData,
        fetchSuccessful,
        isVerificationSectionFilled,
        isAuthorisationSectionFilled,
        filesSocialSecurityNumberVerification,
        filesAuthForm,
        isSocialSecurityBeyondStarted,
        isSocialSecurityCompleted,
        isSocialSecurityPending,
    })
)

/**
 * @deprecated use RTKQ hooks instead
 */
export default socialSecurityProfileSelector
